import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wj75khbxx: FaireProductEntity = {
  token: "p_7wj75khbxx",
  type: "product",
  name: "Winter White Peach Bellini Frozen Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/2e3a1b5b4c1e708ed94d2a05a4b14ab4dea8dd9eee980bc3a6d45aa2d42a282c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96fda16a16c0d382eb1d4dd4bdeb6f7aaedc7fec853f52220341aaa175fd43ee.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Seasonal Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1 750ml bottle of prosecco and 1 750ml bottle of water, shake or stir and throw in the freezer. Then serve right from the bag. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party.\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and holiday design makes merchandising a breeze!\n-Perfect Christmas and hostess gifts for the entire holiday season",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:03.415Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
